import { apiCall } from 'app/dealer/actions';
import { generateApiUrl } from 'app/dealer/utils';

import { remapBranchFromResponse } from '../utils';

import * as ActionTypes from './constants';

export const getBranches = () => {
  return (dispatch, getState) => {
    const state = getState();
    const url = generateApiUrl('/networks/me/dealers');
    const {
      network: { network },
    } = state;

    dispatch({ type: ActionTypes.GET_BRANCHES_REQUEST });
    return dispatch(apiCall(url, {}, !process.env.REACT_APP_MOCK_SERVER,true))
      .then(payload => {
        const { _embedded } = payload;
        const branches =
          _embedded && _embedded.dealers
            ? _embedded.dealers.map(item =>
                remapBranchFromResponse(item, network),
              )
            : [];

        dispatch({
          type: ActionTypes.GET_BRANCHES_SUCCESS,
          payload: branches,
        });
      })
      .catch(error => {
        dispatch({
          type: ActionTypes.GET_BRANCHES_FAILURE,
          error,
        });
      });
  };
};

export const resetBranches = () => {
  return {
    type: ActionTypes.RESET_BRANCHES,
  };
};
